 // src/components/Footer.js
import React from 'react';


const Footer = () => {
  return (
    <footer id='footer' className="footer">
      <p>&copy; 2024 Echofu Ojunugwa Paul | All Rights Reserved</p>
      <div>echofupaul1547@gmail.com</div>
    </footer>
  );
};

export default Footer;
